import React from 'react'
import { DropdownMenu } from 'reactstrap' // or your actual import
import { getContainerProp } from '../Webcomponent/utils/common'
import { useAppSelector } from '../redux/hooks'

type DropdownWrapperProps = React.ComponentProps<typeof DropdownMenu> & {
  dropdownContainer?: HTMLElement | null
}

const DropdownWrapper: React.FC<DropdownWrapperProps> = ({ className, children, ...rest }) => {
  const { dropdownContainer } = useAppSelector((state) => state.templateCustomizer)

  return (
    <DropdownMenu className={className} {...(getContainerProp(dropdownContainer) || {})} {...rest}>
      {children}
    </DropdownMenu>
  )
}

export default DropdownWrapper
